import {
  SET_SELECTED_TEAM,
  SET_SELECTED_DATABOX,
  SET_DATABOX_DOCUMENTS,
  SET_PAGE_SIZE,
  SET_TEAM_TAGS
} from '../constants/databoxConstants'

const initialState = {
  selectedTeam: undefined,
  selectedDatabox: undefined,
  databoxDocuments: undefined,
  pageSize: 10, // can be converted to object for table related properties like sort direction,sortBy
  totalRows: 0,
  teamTags: []
}

const databoxReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_TEAM:
      return { ...state, selectedTeam: action.payload }
    case SET_SELECTED_DATABOX:
      return { ...state, selectedDatabox: action.payload }
    case SET_DATABOX_DOCUMENTS:
      return {
        ...state,
        databoxDocuments: action.payload.rows,
        totalRows: action.payload.totalRows
        // TODO:- add search query to fix issue query string issue.
      }
    case SET_PAGE_SIZE:
      return { ...state, pageSize: action.payload }

    case SET_TEAM_TAGS:
      return { ...state, teamTags: action.payload }

    default:
      return state
  }
}

export default databoxReducer
